import { useId, useState } from "react";
import { Box, Button, ButtonBase, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import PersonOutlineRoundedIcon from "@mui/icons-material/PersonOutlineRounded";
import { coresTextosGlobais, tamanhosControlesGlobais, tamanhosPaginasAdministrativas } from "../../estilos/global";

export default function AnalistaResponsavel({ id, nome, email }) {
  const [aberto, setAberto] = useState(false);
  const tituloId = useId();
  const nomeCompleto = nome?.trim() || "Nome não disponível";
  const emailCompleto = email?.trim() || "E-mail não informado";
  const estiloTexto = { color: coresTextosGlobais.conteudoTabela, fontSize: tamanhosPaginasAdministrativas.conteudoTabela, lineHeight: 1.4, overflowWrap: "anywhere" };

  if (!id) return <Typography sx={estiloTexto}>Não atribuído</Typography>;

  return (
    <>
      <ButtonBase
        onClick={() => setAberto(true)}
        aria-label={`Ver dados do analista responsável: ${nomeCompleto}`}
        aria-haspopup="dialog"
        sx={{ ...estiloTexto, display: "block", maxWidth: "100%", textAlign: "left", borderRadius: "3px", textDecoration: "underline", textDecorationColor: "var(--sear-borda-forte, #8cbeef)", textUnderlineOffset: "3px", "&:hover": { color: "var(--sear-azul, #087cf0)" }, "&.Mui-focusVisible": { outline: "2px solid var(--sear-azul, #087cf0)", outlineOffset: 3 } }}
      >
        {nomeCompleto}
      </ButtonBase>
      <Dialog open={aberto} onClose={() => setAberto(false)} fullWidth maxWidth="xs" aria-labelledby={tituloId} PaperProps={{ sx: { borderRadius: "10px", borderTop: "4px solid var(--sear-borda-forte, #087cf0)", bgcolor: "var(--sear-superficie, #fff)" } }}>
        <DialogTitle id={tituloId} sx={{ display: "flex", alignItems: "center", gap: 1, px: 2.5, py: 2, color: coresTextosGlobais.tituloPagina, fontSize: tamanhosPaginasAdministrativas.tituloSecao, fontWeight: 600 }}>
          <PersonOutlineRoundedIcon sx={{ color: "var(--sear-azul, #087cf0)" }} />
          Analista responsável
        </DialogTitle>
        <DialogContent sx={{ px: 2.5, pt: "8px !important", pb: 2.5 }}>
          <Box component="dl" sx={{ m: 0, display: "grid", gap: 2, "& dt": { color: "var(--sear-texto-secundario, #6983a4)", fontSize: tamanhosControlesGlobais.rotulo }, "& dd": { ...estiloTexto, m: 0, mt: 0.5, userSelect: "text" } }}>
            <Box><Typography component="dt">Nome completo</Typography><Typography component="dd">{nomeCompleto}</Typography></Box>
            <Box><Typography component="dt">E-mail</Typography><Typography component="dd">{emailCompleto}</Typography></Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 2.5, py: 1.5, borderTop: "1px solid var(--sear-borda, #dfebf8)" }}>
          <Button autoFocus variant="outlined" onClick={() => setAberto(false)} sx={{ textTransform: "none", fontSize: tamanhosControlesGlobais.botao, borderRadius: "6px", borderColor: "var(--sear-borda, #c7dff8)" }}>Fechar</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
